<script setup>
  import {ref, onMounted, watch, computed, getCurrentInstance, toRaw, onBeforeUnmount, inject, defineExpose} from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import {usePageLoadingStore} from "../../../../../../stores/pageLoading";
  import {useUserStore} from "../../../../stores/user";
  import jobFairCorpService from "@/pages/user/services/jobFair/jobFairCorpService";
  import KSATextButton from "../../../../../../components/ui-components/button/KSATextButton.vue";
  import JobFairResumeDetailModal from '../../../../components/modal/jobFair/JobFairResumeDetailModal.vue';
  import mypageJobFairService from '../../../../services/mypage/jobFair/mypageJobFairService';
  import _ from "lodash";
  import JobFairIntvProposalJobNoticeListModal from '../../../../components/modal/jobFair/JobFairIntvProposalJobNoticeListModal.vue';
  import { storeToRefs } from 'pinia';

  const route = useRoute()
  const router = useRouter()
  const loadingStore = usePageLoadingStore()

  const { user, isAuthenticated } = storeToRefs(useUserStore());
  const { $pageListBoardNo } = getCurrentInstance().appContext.config.globalProperties;

  const globals = getCurrentInstance().appContext.config.globalProperties;
  const { $gbNameKR, $regex, $gb : { EMPLOYEE_NUM_GB, SALES_AMT_GB }, alert, confirm } = globals;

  const currentPage = ref(1);
  const pageSize = ref(10);
  const totalPages = ref(1);
  const totalCount = ref(0);
  const list = ref([]); // 관심 인재

  const pageSizeGroup = ref([
    { label:"10개씩 보기", value: 10 },
    { label:"30개씩 보기", value: 30 },
    { label:"50개씩 보기", value: 50 },
    { label:"100개씩 보기", value: 100 },
  ])

  // 모달
  const jobFairResumeModal = ref(null); // 특별채용관 이력서
  const intvProposalJobNoticeListModal = ref(null);// 면접제안 > 채용공고 선택 모달

  // 페이징 개수 변경
  const onSelectPageSize = (option) => {
    pageSize.value = option.value;
    currentPage.value = 1;
    retrieveList();
  }

  // 페이지 클릭
  const onSelectPage = (pageNo, depth) => {
    currentPage.value = pageNo;
    retrieveList();
  }

  // 조회
  const retrieveList = () => {
    const paramObj = {
      pageNumber: currentPage.value || 0,
      size: pageSize.value || 10,
    };

    loadingStore.loading = true;
    mypageJobFairService.retrieveInterestHallEntryListPaging(paramObj)
      .then( (res) => {
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
        loadingStore.loading = false;
      })
      .catch( (error) =>  {
        loadingStore.loading = false;
      });
  }

  // 이력서 보기
  const onClickMyResume = async (resumeId, interestYn, delYn) => {
     if (delYn === 'Y') {
      alert(["삭제된 이력서 입니다."]);
    } else {
      await jobFairResumeModal.value.show({
        resumeId,
        interestYn,
      });
      retrieveList();
    }
  }

  // 관심 삭제
  const onClickDeleteInterestYn = async (user) => {
    const interestYn = user.interestYn !== 'N' ? 'N' : 'Y';
    const interestYnName = interestYn === 'N' ? '삭제' : '등록';
    const ok = await confirm([`관심인재를 ${interestYnName}하시겠습니까?`], `관심인재 ${interestYnName}`);
    if(ok) {
      let paramObj = {
        resumeId: user.resumeId,
        interestYn,
      }
      mypageJobFairService.updateCorpInterestHallEntryYn(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            alert(`${interestYnName}하였습니다.`);
            user.interestYn = interestYn;
          } else {
            alert(`${interestYnName}를 실패하였습니다.`);
          }
          retrieveList();
        })
        .catch( (res) =>  {
          alert(`${interestYnName}를 실패하였습니다.`);
          loadingStore.loading = false;
        });
    }
  }

  // 면접제안 등록
  const onClickInterviewProposal = async (resumeId) => {
    const result = await intvProposalJobNoticeListModal.value.show({
      corpId: user?.value?.userInfo?.corporation?.corpId || '',
      resumeId,
    });

    if(result && result.jobNoticeSeq) {
      const paramObj = {
        resumeId,
        jobNoticeSeq: result.jobNoticeSeq,
      };

      loadingStore.loading = true;
      mypageJobFairService.createInterviewProposalEntry(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            alert(["면접제안을 하였습니다."]);
            retrieveList();
          } else {
            alert(["면접제안을 실패하였습니다."]);
          }
        })
        .catch( (error) =>  {
          alert(["면접제안을 실패하였습니다."]);
          loadingStore.loading = false;
        }); 
    }
  }

  onMounted(()=>{
    retrieveList();
  });
</script>

<template>
  <div class="table-form">
    <div class="list-top">
      <p>총 <span>{{ $number(totalCount)}}</span>개</p>
      <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
    </div>
    <div class="table-form">
      <table class="table-form board-mobile-vertical">
        <tr>
          <th>번호</th>
          <th>이름</th>
          <th>이력서 제목</th>
          <th>관심 카테고리</th>
          <th>전공계열(주전공)</th>
          <th>관심 등록일</th>
          <th>면접제안</th>
          <th>관심삭제</th>
        </tr>
        <tr v-for="user in list">
          <td>{{ user.boardNo }}</td>
          <td>{{ user.userName }}</td>
          <td>
            <p class="file text-overflow long-overflow" v-if="user.fileYn === 'Y'" v-for="resumeAttaches in user.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
              {{ resumeAttaches.fileName }}
            </p>
            <p class="clickable blue text-overflow long-overflow" v-else @click="onClickMyResume(user.resumeId, user.interestYn, user.delYn)">
              {{ user.title }}
            </p>
          </td>
          <td>{{ user.interests }}</td>
          <td>
            {{ $gbNameKR('MAJOR_GB', user.majorGb) }}
          </td>
          <td>{{ $yyyymmddHHmmss(user.modifyDate) }}</td>
          <td>
            <span v-if="user.resOpenYn !== 'Y'" class="gray">제안불가</span>
            <KSATextButton v-else-if="!user.intvPropStateGb" text="면접제안" @click="onClickInterviewProposal(user.resumeId)"/>
            <span v-else class="gray">{{ ($gbNameKR('ADMIN_INTV_PROP_STATE_GB',user.intvPropStateGb))?.replace("제안보냄", "제안완료") }}</span>
          </td>
          <td>
            <KSATextButton :text="user.interestYn !== 'N' ? '♥' : '♡'" @click="onClickDeleteInterestYn(user)" class="red_button"></KSATextButton>
          </td>
        </tr>
      </table>
    </div>
    <div class="result-none lecture-none" v-if="list.length === 0">
      등록된 관심인재가 없습니다.
    </div>
    <Paginate
        v-if="list.length > 0"
        v-model="currentPage"
        :page-count="totalPages"
        :click-handler="onSelectPage"
    />
  </div>
  <JobFairResumeDetailModal ref="jobFairResumeModal"/> <!-- 특별채용관 이력서 상세 -->
  <JobFairIntvProposalJobNoticeListModal ref="intvProposalJobNoticeListModal" /> <!--면접제안 > 채용공고 선택 모달 -->
</template>

<style lang="scss" scoped>
@import "../../../../../../assets/scss/theme";

.blue {
  color: $blue_color;
}

.file {
  color: $blue_color;
  cursor: pointer;
}

.etc-box {
  display: inline-block;
  width: 200px;
}

.category-wrap {
  .disabled {
    background: $gray-light_color;
    cursor: default;
  }
}

.instructions {
  background: $gray-regular_color;
  padding: 20px;
  p {
    &:before {
      content: "ㆍ";
    }
    .red {
      display: inline-block;
      color: $red_color;
    }
  }
}

.state-box {
  border: 2px solid $black_color;
  border-bottom: 0;
  padding: 10px 20px;
  span {
    color: $blue_color;
  }
}
.table-form {
  table {
    &.vertical {
      &.align-left {
        th {
          text-align: left;
          span {
            display: block;
            font-size: $font-size_xs;
            color: $gray_color;
            font-weight: normal;
            &.mark {
              font-size: $font-size_sm;
              color: $black_color;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
  .clickable {
    text-decoration: underline;
    cursor: pointer;
  }
}
.board-detail {
  .header {
    border-top: 0;
  }
  .table-form {
    table {
      border-top: 0;
    }
  }
}
</style>